import { useState, useEffect, useCallback } from 'react';
import { getJobs } from '../api/jobs';
import { useSocket } from '../context/SocketContext';

// Sprint 2.8.6 T7-D — page parametresi externally controlled (BranchesListPage pattern):
// JobsPage page state'i tutar, filter değişikliklerinde setPage(1) zorunlu.
// Hook setPage döndürmez — tüketici sorumlu.
export function useJobs(filters = {}, page = 1) {
  const [jobs, setJobs] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 20 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { socket } = useSocket();

  const load = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const data = await getJobs({ ...filters, page, ...params });
      setJobs(data.jobs);
      setPagination(data.pagination);
    } catch (e) {
      setError(e.response?.data?.error || 'Yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  }, [JSON.stringify(filters), page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);

  // Gerçek zamanlı güncellemeler
  useEffect(() => {
    if (!socket) return;
    const refresh = () => load();
    socket.on('job:created', refresh);
    socket.on('job:updated', refresh);
    socket.on('job:status_changed', refresh);
    socket.on('job:deleted', refresh);
    return () => {
      socket.off('job:created', refresh);
      socket.off('job:updated', refresh);
      socket.off('job:status_changed', refresh);
      socket.off('job:deleted', refresh);
    };
  }, [socket, load]);

  return { jobs, pagination, loading, error, reload: load };
}
